module.exports = __webpack_public_path__ + "img/donante-novelty.c972fef0.png";